import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { Form, Spinner } from "reactstrap";
import moment from "moment/moment";
import { EContentService } from "../../../globals/services/enhancedContent.service";
import { useSelector } from "react-redux";
import styles from "./Volume.module.scss";
import { useLocation } from "react-router-dom";
import { STATUS, TABS } from "../constants/index";
import EditHeader from "../components/EditHeader";
import FormField from "../components/FormField";
import SelectField from "../components/SelectField";

export const Volume = () => {
    const location = useLocation();
    const { volumeItem } = location.state || {};

    const history = useHistory();
    const { _id, title, status, description, division, createdBy, created } = volumeItem || {};
    const { me } = useSelector((state) => state.auth);
    const eContentService = EContentService()
    const [volumeState, setVolumeState] = useState({
        _id: _id || null,
        title: title || null,
        status: status || null,
        description: description || null,
        division: division || ['FTJ'],
        createdBy: createdBy || me?._id || null,
        created: created || moment().format('YYYY-MM-DD'),
        modifiedBy: me ? me._id : null,
        modified: moment().format('YYYY-MM-DD'),
    });
    const [hasChanges, setHasChanges] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isMounted, setIsMounted] = useState(true);

    useEffect(() => {
        return () => setIsMounted(false);
    }, []);


    const handleChange = (updates) => {
        setVolumeState((prevState) => ({
            ...prevState,
            ...updates
        }));
        setHasChanges(true);
    }

    const handleSaveVolume = async () => {
        try {
            setIsLoading(true);
            const saveOperation = volumeState._id ? eContentService.updateVolume : eContentService.createVolume;
            await saveOperation(volumeState);
            if (isMounted) {
                navigateToVolumesList();
            }
        } catch (error) {
            console.error('Error saving volume:', error);
        } finally {
            setIsLoading(false);
        }
    }

    const handleDeleteVolume = async () => {
        try {
            setIsLoading(true);
            await eContentService.deleteVolume(volumeState._id);
            if (isMounted) {
                navigateToVolumesList();
            }
        } catch (error) {
            console.error('Error deleting volume:', error);
        } finally {
            setIsLoading(false);
        }
    }

    const navigateToVolumesList = () => {
        history.push('/curricula', { curriculaActiveTab: TABS.VOLUMES });
    };

    return (
        <div className="content">
            {isLoading && (
                <div className={styles.loaderOverlay}>
                    <Spinner color="primary" />
                </div>
            )}
            <div className="page-content">
                <div className="container-fluid">
                    <div className={styles.section}>
                        <EditHeader
                            title="Volume"
                            subTitle="description"
                            createNew={!volumeState._id}
                            hasChanges={hasChanges}
                            handleSave={handleSaveVolume}
                            handleDelete={handleDeleteVolume}
                            handleGoBack={navigateToVolumesList}
                        />

                        <div className="col-12 col-md-10">
                            <Form>
                                <FormField
                                    type="text"
                                    title="Volume Name"
                                    name="title"
                                    value={volumeState.title || ""}
                                    onChange={(e) => handleChange({ title: e.target.value })}
                                />
                                <FormField
                                    type="textarea"
                                    title="Volume Description"
                                    name="description"
                                    value={volumeState.description || ""}
                                    onChange={(e) => handleChange({ description: e.target.value })}
                                />
                                <div className="col-12 col-md-5">
                                    <SelectField
                                        label="Status"
                                        options={Object.values(STATUS).map((status) => ({ label: status, value: status }))}
                                        value={volumeState.status || ""}
                                        name="status"
                                        onChange={(name, value) => handleChange({ [name]: value })}
                                        minHeight={55}
                                    />
                                </div>
                            </Form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}